module.exports = __webpack_public_path__ + "media/images/lig-logo-shadow-9c5acc65f686daf91a434dbf5fe4c41a.svg";